import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from '@app/core/services/data.service';
import { Observable, Subject, map } from 'rxjs';
import { dictionaryItems } from '@app/core/constants/dictionaryItems';
import { ConfigurationService } from '@app/core/shell/services/configuration.service';

@Injectable({
    providedIn: 'root'
})
export class PaymentService {

    api: any;
    payment: any;
    private orderSubject = new Subject<any>();
    private order = {
        amount: null,
        code: null,
        date: null
    };

    constructor(private http: HttpClient, private dataService: DataService, private configService: ConfigurationService) {
        //  this.api.transactionApiUrl = this.configService.getConfig()?.shell.api.transactionApiUrl;
        //  this.api.paymentsApiUrl = this.configService.getConfig()?.shell.api.paymentsApiUrl;
    }

    getOrder(): any {
        console.log("Getting order ", this.order);
        return this.order;
    }

    setOrder(value: any): void {
        this.order = value;
        this.orderSubject.next(value);
        console.log("Set order to ", this.order);
    }

    subscribeOrder(obj: any) {
        return this.orderSubject.subscribe(obj);
    }

    getEnablePaymentPage() {
        return this.configService.getConfig()?.shell.switches.enablePaymentPage;
    }

    convertToCurrencyText(value: any, alwaysPositive?: boolean) {
        let retval = "£0.00";

        if (value) {
            if (typeof value === 'string') {
                value = parseFloat(value);
            }
            retval = value < 0 ? "-£" + (0 - value).toFixed(2) : "£" + value.toFixed(2);
        }

        if (alwaysPositive) {
            retval = retval.replace("-", "");
        }

        return retval;
    }

    convertToCreditType(value: any, dictionary: any) {
        const chargeText = this.dataService.getDictionaryItemByKeyAndLanguage(dictionary, dictionaryItems.charge, "en-GB");
        const paymentText = this.dataService.getDictionaryItemByKeyAndLanguage(dictionary, dictionaryItems.payment, "en-GB");

        if (value) {
            return value > 0 ? paymentText : chargeText;
        }
    }

    convertDateToText(date: any) {
        if (date) {
            return date.format('DD MMM YY');
        }
    }

    convertTimeToText(time: any) {
        if (time) {
            return time.format('h:mm:ss a');
        }
    }

    getBalance(tenancyReference: string, subAccount: number): Observable<any> {
        const transactionApiUrl = this.configService.getConfig()?.shell.api.transactionApiUrl;
        console.log(transactionApiUrl);
        return this.http.get(`${transactionApiUrl}balance?tenancyReference=${tenancyReference}&subAccount=${subAccount}`, { observe: 'response' })
            .pipe(
                map(response => response),
                // catchError(error => {
                //     throw 'Error in getting balance: ' + error;
                // })
            );
    }


    // getBalance(tenancyReference: string, subAccount: number): Observable<any> {
    //     return this.http.get<any>(this.api.transactionApiUrl + 'balance?tenancyReference=' + tenancyReference + '&subAccount=' + subAccount);
    // }

    getCharges(tenancyReference: string, subAccount: number): Observable<any> {
        const transactionApiUrl = this.configService.getConfig()?.shell.api.transactionApiUrl;
        return this.http.get(transactionApiUrl + 'charges?tenancyReference=' + tenancyReference + '&subAccount=' + subAccount);

    }

    getChargesBreakdown(tenancyReference: string, subAccount: number): Observable<any> {
        const transactionApiUrl = this.configService.getConfig()?.shell.api.transactionApiUrl;
        return this.http.get(transactionApiUrl + 'chargesbreakdown?tenancyReference=' + tenancyReference + '&subAccount=' + subAccount);

    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getSubAccountBreakdown(tenancyReference: string, _subAccount: number): Observable<any> {
        const transactionApiUrl = this.configService.getConfig()?.shell.api.transactionApiUrl;
        return this.http.get(transactionApiUrl + tenancyReference + '/subaccounts');

    }

    getTransactions(tenancyReference: string, subAccount: number, startDate: any, endDate: any): Observable<any> {
        const transactionApiUrl = this.configService.getConfig()?.shell.api.transactionApiUrl;
        return this.http.get(transactionApiUrl + 'transactions?tenancyReference=' + tenancyReference + '&subAccount=' + 0 + '&startDate=' + startDate.format('YYYY[%2F]MM[%2F]DD') + '&endDate=' + endDate.format('YYYY[%2F]MM[%2F]DD'))

    }

    postPaymentToWorldPay(card: string): Observable<any> {
        const worldPayClientKey = this.configService.getConfig()?.shell.api.worldPayClientKey;
        const worldPayUrl: any = this.configService.getConfig()?.shell.api.worldPayUrl;
        this.payment = {
            reusable: true,
            paymentMethod: card,
            clientKey: worldPayClientKey
        };

        console.log("Posting to WorldPay API");
        return this.http.post(worldPayUrl, this.payment);
    }

    postPaymentToApi(payment: string): Observable<any> {
        const paymentsApiUrl = this.configService.getConfig()?.shell.api.paymentsApiUrl;
        console.log("Posting to Payments API");
        return this.http.post(paymentsApiUrl + 'payments', payment);
    }

}
